import { ENV } from '@/constants';

export const schemaObject_Main = {
	'@context': 'https://schema.org',
	'@graph': [
		{
			'@type': 'WebPage',
			'@id': 'https://liftapp.ai',
			url: 'https://liftapp.ai',
			name: 'A simpler way to create and edit with AI',
			description:
				'Edit photos, generate images and video, work with audio, and more — all in one place.',
			mainEntity: [
				{ '@id': 'https://liftapp.ai#photo-editor' },
				{ '@id': 'https://liftapp.ai#ai-tools' },
				{ '@id': 'https://liftapp.ai#faq' },
				{ '@id': 'https://liftapp.ai#all-in-one' },
			],
		},

		{
			'@type': 'Product',
			'@id': 'https://liftapp.ai#photo-editor',
			name: 'Lift AI Photo Editor',
			description:
				'Lift’s AI Photo Editor lets you remove backgrounds, upscale images to 4K, and apply creative filters — all in one place."',
			image: 'https://liftapp.ai/seo-image.webp',
			brand: {
				'@type': 'Brand',
				name: 'Lift',
			},
			aggregateRating: {
				'@type': 'AggregateRating',
				ratingValue: '4.8',
				reviewCount: 130000,
				bestRating: '5',
				worstRating: '1',
			},
			interactionStatistic: [
				{
					'@type': 'InteractionCounter',
					interactionType: { '@type': 'InstallAction' },
					userInteractionCount: 13000000,
				},
			],
		},

		{
			'@type': 'ItemList',
			'@id': 'https://liftapp.ai#ai-tools',
			name: 'AI Tools for Image, Video and Audio',
			description:
				'Edit photos, generate images and video, work with audio, and more — all in one place.',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					url: 'https://liftapp.ai/tools',
					name: 'All AI Tools',
					brand: { '@type': 'Brand', name: 'Lift' },
				},
				{
					'@type': 'ListItem',
					position: 2,
					url: 'https://liftapp.ai/ai-image-generator',
					name: 'AI Image Generator',
					brand: { '@type': 'Brand', name: 'Lift' },
				},
				{
					'@type': 'ListItem',
					position: 3,
					url: 'https://liftapp.ai/image-enhancer',
					name: 'AI Image Enhancer',
					brand: { '@type': 'Brand', name: 'Lift' },
				},
				{
					'@type': 'ListItem',
					position: 4,
					url: 'https://liftapp.ai/background-remover',
					name: 'AI Background Remover',
					brand: { '@type': 'Brand', name: 'Lift' },
				},
				{
					'@type': 'ListItem',
					position: 5,
					url: 'https://liftapp.ai/object-remover',
					name: 'AI Object Remover',
					brand: { '@type': 'Brand', name: 'Lift' },
				},
				{
					'@type': 'ListItem',
					position: 6,
					url: 'https://liftapp.ai/headshot-generator',
					name: 'AI Headshot Generator',
					brand: { '@type': 'Brand', name: 'Lift' },
				},
				{
					'@type': 'ListItem',
					position: 7,
					url: 'https://liftapp.ai/ai-video-generator',
					name: 'AI Video Generator',
					brand: { '@type': 'Brand', name: 'Lift' },
				},
				{
					'@type': 'ListItem',
					position: 8,
					url: 'https://liftapp.ai/image-to-video',
					name: 'Image to Video AI',
					brand: { '@type': 'Brand', name: 'Lift' },
				},
				{
					'@type': 'ListItem',
					position: 9,
					url: 'https://liftapp.ai/video-background-remover',
					name: 'Video Background Remover',
					brand: { '@type': 'Brand', name: 'Lift' },
				},
				{
					'@type': 'ListItem',
					position: 10,
					url: 'https://liftapp.ai/video-enhancer',
					name: 'Video Enhancer',
					brand: { '@type': 'Brand', name: 'Lift' },
				},
				{
					'@type': 'ListItem',
					position: 11,
					url: 'https://liftapp.ai/video-to-mp3-converter',
					name: 'Video to MP3 Converter',
					brand: { '@type': 'Brand', name: 'Lift' },
				},
				{
					'@type': 'ListItem',
					position: 12,
					url: 'https://liftapp.ai/mp3-converter',
					name: 'MP3 Converter',
					brand: { '@type': 'Brand', name: 'Lift' },
				},
			],
		},

		{
			'@type': 'FAQPage',
			'@id': 'https://liftapp.ai#faq',
			mainEntity: [
				{
					'@type': 'Question',
					name: 'What can I do with Lift?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Lift brings 50+ AI tools for images, video and audio together in one place. Edit and enhance photos, remove backgrounds and objects, generate images and videos from text, convert and compress files, and more — right in your browser. See all tools here.',
					},
				},
				{
					'@type': 'Question',
					name: 'Can I try Lift before I pay?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Yes. Lift Pro starts with a 7-day trial at an introductory price, so you can try every tool before committing. There’s no free plan. After the trial, the subscription renews at the regular price unless you cancel — cancel before the trial ends and you won’t be charged again. See plans here.',
					},
				},
				{
					'@type': 'Question',
					name: 'Is my content private and secure?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Your uploads are used to process your requests and create your results. You can learn how we collect, store and protect your data in our Privacy Policy.',
					},
				},
				{
					'@type': 'Question',
					name: 'What files can I use with Lift?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'Lift works with the most popular formats: images (JPG, PNG, WEBP, HEIC, BMP, TIFF), video (MP4, MOV, AVI, MKV, WEBM, GIF) and audio (MP3, WAV). Built-in converters also help you change files from one format to another.',
					},
				},
				{
					'@type': 'Question',
					name: 'How can I cancel my Lift Pro Subscription?',
					acceptedAnswer: {
						'@type': 'Answer',
						text: 'You can cancel your trial or subscription through your account settings or by contacting support@liftapp.ai. Cancellation stops automatic renewal, while access remains active until the end of the current period.',
					},
				},
			],
		},

		{
			'@type': 'SoftwareApplication',
			'@id': 'https://liftapp.ai#all-in-one',
			name: 'Try Lift – AI Content Creation Tools',
			description:
				'Your all-in-one tools to create, edit, and elevate your content. Create stunning content with AI tools, templates, and editing features effortlessly.',
			operatingSystem: 'iOS, Android, Web',
			applicationCategory: 'MultimediaApplication',
			url: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
			applicationSubCategory: 'Content Creation',
			publisher: {
				'@type': 'Organization',
				name: 'Lift',
				url: 'https://liftapp.ai',
			},
			potentialAction: [
				{
					'@type': 'ViewAction',
					name: 'Open Web App',
					target: `${ENV.LIFT_WEB_APP_URL}/sign-in?auto_login=true`,
				},
			],
		},

		{
			'@type': 'BreadcrumbList',
			itemListElement: [
				{
					'@type': 'ListItem',
					position: 1,
					name: 'Home',
					item: 'https://liftapp.ai',
				},
			],
		},
	],
};
